import { render, staticRenderFns } from "./NsTaxId.vue?vue&type=template&id=31ff6f12&scoped=true&"
import script from "./NsTaxId.vue?vue&type=script&lang=js&"
export * from "./NsTaxId.vue?vue&type=script&lang=js&"
import style0 from "./NsTaxId.vue?vue&type=style&index=0&id=31ff6f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff6f12",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ff6f12')) {
      api.createRecord('31ff6f12', component.options)
    } else {
      api.reload('31ff6f12', component.options)
    }
    module.hot.accept("./NsTaxId.vue?vue&type=template&id=31ff6f12&scoped=true&", function () {
      api.rerender('31ff6f12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/ns-taxid/NsTaxId.vue"
export default component.exports